<template>
  <template v-if="variants.v1 === variant">
    <section
      id="fee-calculator"
      class="layout-pt-lg layout-pb-lg"
      :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? vars.textColor : 'var(--c-text-secondary)'}`"
    >
      <div class="container">
        <div class="tw-grid tw-w-full lg:tw-grid-cols-12" style="color: var(--c-text-primary)">
        <div
          :class="`${vars.isReversedBool && 'tw-order-3'}`"
          class="tw-col-span-12 tw-flex tw-w-full tw-flex-col tw-gap-5 lg:tw-col-span-5 lg:tw-self-start"
        >
          <h2 v-if="vars.sectionTitleText">{{ vars.sectionTitleText }}</h2>
          <div v-if="vars.sectionTitleHtml" v-html="vars.sectionTitleHtml"></div>
          <library-image
            v-if="vars.photoImage && !vars.videoUrl"
            :src="vars.photoImage"
            :alt="vars.titleText"
            class="tw-w-full tw-rounded-xl tw-object-cover"
            :class="{
              'xl:tw-col-start-1 xl:tw-row-start-1': vars.isReversedBool,
            }"
          />
          <library-iframe
            v-if="vars.videoUrl"
            class="tw-aspect-[16/9] tw-w-full tw-rounded-xl tw-object-cover"
            :src="vars.videoUrl"
            style="border-radius: var(--rounded)"
            frameborder="0"
            allowfullscreen
          ></library-iframe>
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`card-btn-${index}`"
            :class="`n-${button.type} tw-mb-5 tw-self-start`"
            :to="button.link"
            :external="true"
          >
            {{ button.label }}
          </nuxt-link>
        </div>
        <div :class="`${vars.isReversedBool && 'tw-order-2'} tw-col-span-1 tw-hidden lg:tw-block`"></div>

        <div class="tw-col-span-12 tw-space-y-5 lg:tw-col-span-6">
          <h2 v-if="vars.mainTitleText">{{ vars.mainTitleText }}</h2>
          <div v-if="vars.descriptionText">
            <p>{{ vars.descriptionText }}</p>
          </div>
          <h4>{{ vars.subTitleText }}</h4>
          <div class="tw-space-y-1">
            <label for="fee-calculator">Asking Price</label>
            <div>
              <input
                style="border: 1px solid var(--c-border); background-color: #fff"
                ref="priceInput"
                id="fee-calculator"
                type="number"
                class="fee-input"
              />
            </div>
          </div>
          <button
            class="md:tw-hidden"
            @click="calculate"
            :class="`n-${vars.calculateButtonTypeText} tw-max-w-full !tw-whitespace-normal tw-break-all`"
          >
          {{ vars.calculateButtonLabelText }}
        </button>
          <button
            class="tw-hidden md:tw-block"
            @click="calculate"
            :class="`n-${vars.calculateButtonTypeText} tw-max-w-full !tw-whitespace-normal tw-break-all`"
          >
            {{ vars.calculateButtonLabelText }}
          </button>
          <h4>Our Result</h4>
          <div class="tw-space-y-1">
            <p>{{ vars.resultLabelText }}</p>
            <button
              :class="`n-${vars.calculateButtonTypeText}`"
              class="tw-pointer-events-none tw-flex tw-items-center tw-my-4"
              style="font-family: var(--f-secondary) !important; background-color: var(--c-primary); color: var(--c-text_tertiary);"
            >
              <h4>£ {{ result }}</h4>
            </button>
            <p v-if="vars.resultDescriptionText">{{ vars.resultDescriptionText }}</p>
          </div>
        </div>
      </div>
      </div>
    </section>
  </template>

  <template v-else-if="variants.v2 === variant">
    <section
      id="fee-calculator"
      class="layout-pt-lg layout-pb-lg"
      :style="`background-color: var(--c-${vars.backgroundColor});color: ${vars.textColor ? vars.textColor : 'var(--c-text-secondary)'}`"
    >
      <div class="container">
        <div class="tw-grid tw-w-full lg:tw-grid-cols-12" style="color: var(--c-text-primary)">
        <div
          :class="`${vars.isReversedBool && 'tw-order-3'}`"
          class="tw-col-span-12 tw-flex tw-w-full tw-flex-col tw-gap-5 lg:tw-col-span-5 lg:tw-self-start"
        >
          <h2 v-if="vars.sectionTitleText">{{ vars.sectionTitleText }}</h2>
          <div v-if="vars.sectionTitleHtml" v-html="vars.sectionTitleHtml"></div>
          <library-image
            v-if="vars.photoImage && !vars.videoUrl"
            :src="vars.photoImage"
            :alt="vars.titleText"
            class="tw-w-full tw-rounded-xl tw-object-cover"
            :class="{
              'xl:tw-col-start-1 xl:tw-row-start-1': vars.isReversedBool,
            }"
          />
          <library-iframe
            v-if="vars.videoUrl"
            class="tw-aspect-[16/9] tw-w-full tw-rounded-xl tw-object-cover"
            :src="vars.videoUrl"
            style="border-radius: var(--rounded)"
            frameborder="0"
            allowfullscreen
          ></library-iframe>
          <nuxt-link
            v-for="(button, index) in buttons"
            :key="`card-btn-${index}`"
            :class="`n-${button.type} tw-mb-5 tw-self-start`"
            :to="button.link"
            :external="true"
          >
            {{ button.label }}
          </nuxt-link>
        </div>
        <div :class="`${vars.isReversedBool && 'tw-order-2'} tw-col-span-1 tw-hidden lg:tw-block`"></div>

        <div class="tw-col-span-12 tw-space-y-5 lg:tw-col-span-6">
          <h2 v-if="vars.mainTitleText">{{ vars.mainTitleText }}</h2>
          <div v-if="vars.descriptionText">
            <p>{{ vars.descriptionText }}</p>
          </div>
          <h4>{{ vars.subTitleText }}</h4>
          <div class="tw-space-y-1">
            <label for="fee-calculator">Asking Price</label>
            <div>
              <input
                style="border: 1px solid var(--c-border); background-color: #fff"
                ref="priceInput"
                id="fee-calculator"
                type="number"
                class="fee-input"
              />
            </div>
          </div>

          <div class="fee-percentage-container tw-space-y-2">
            <label class="fee-percentage-label">FEE PERCENTAGE</label>
            <div class="tw-text-center">
              <h4 class="fee-percentage-value">{{ formattedFeePercentage }}%</h4>
            </div>
            <div class="slider-component">
              <div class="slider-labels">
                <span class="fee-percentage-minmax">1.25%</span>
                <span class="fee-percentage-minmax">1.75%</span>
              </div>
              <div class="slider-input-wrapper">
                <div class="slider-track"></div>
                <input
                  v-model="feePercentage"
                  type="range"
                  min="1.25"
                  max="1.75"
                  step="0.01"
                  class="fee-percentage-slider"
                />
              </div>
            </div>
          </div>

          <button
            class="md:tw-hidden"
            @click="calculate"
            :class="`n-${vars.calculateButtonTypeText} tw-max-w-full !tw-whitespace-normal tw-break-all`"
          >
          {{ vars.calculateButtonLabelText }}
          </button>
          <button
            class="tw-hidden md:tw-block"
            @click="calculate"
            :class="`n-${vars.calculateButtonTypeText} tw-max-w-full !tw-whitespace-normal tw-break-all`"
          >
            {{ vars.calculateButtonLabelText }}
          </button>
          <h4>Our Result</h4>
          <div class="tw-space-y-1">
            <p>{{ vars.resultLabelText }}</p>
            <button
              :class="`n-${vars.calculateButtonTypeText}`"
              class="tw-pointer-events-none tw-flex tw-items-center tw-my-4"
              style="font-family: var(--f-secondary) !important; background-color: var(--c-primary); color: var(--c-text_tertiary);"
            >
              <h4>£ {{ result }}</h4>
            </button>
            <p v-if="vars.resultDescriptionText">{{ vars.resultDescriptionText }}</p>
          </div>
        </div>
      </div>
      </div>
    </section>
  </template>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'FeeCalculator',
  
  mixins: [ComponentMixin],

  data() {
    return {
      result: '0.00',
      feePercentage: '1.50',
      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },
  methods: {
    calculate() {
      const priceInput = this.$refs.priceInput as HTMLInputElement;
      if (!priceInput || !priceInput.value) {
        this.result = '0.00';
        return;
      }
      const price = Number(priceInput.value);

      if (this.variant === this.variants.v2) {
        const fee = (price * parseFloat(this.feePercentage)) / 100;
        this.result = fee.toLocaleString('en-GB', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        });
      } else {
        const achievedUs = (price * 101.29) / 100;
        const achievedOther = (price * 96.3) / 100;
        const feeUs = (achievedUs * 1.8) / 100;
        const feeOther = (achievedOther * 1) / 100;
        const achievedAfterFeeUs = achievedUs - feeUs;
        const achievedAfterFeeOther = achievedOther - feeOther;

        const cost = Math.round(achievedAfterFeeUs - achievedAfterFeeOther);
        this.result = cost.toLocaleString();
      }
    },
  },
  computed: {
    buttons() {
      return this.groupedVariables.buttons;
    },

    formattedFeePercentage() {
      return parseFloat(this.feePercentage).toFixed(2);
    },
  },
});
</script>
